import { c as _c } from "react/compiler-runtime";
import { ExchangeArrowsIcon, Dialog, SphereXgLogo, Text } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
import { IntegrationIcon } from "@pages/project-details/project-integrations/integration-icon";
import { INTEGRATION_INFO } from "@src/constants/integrations-constants";
import { memo } from "react";
/** The Sphere XG logomark, as tall as the logo inside an integration's tile */
function SphereLogomark() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <SphereXgLogo variant="mini" height="65px" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}

/** Renders project integration connected dialog */
function ProjectIntegrationsConnectedDialogComponent(t0) {
  const $ = _c(18);
  const {
    integrationId,
    onClose
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      textAlign: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      alignItems: "center",
      gap: 3,
      marginY: "60px",
      marginX: "auto"
    };
    t3 = <IntegrationIcon icon={SphereLogomark} />;
    t4 = <ExchangeArrowsIcon />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  const t5 = INTEGRATION_INFO[integrationId];
  let t6;
  if ($[4] !== t5.icon) {
    t6 = <Box sx={t2}>{t3}{t4}<IntegrationIcon icon={t5.icon} /></Box>;
    $[4] = t5.icon;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      marginBottom: "10px"
    };
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = INTEGRATION_INFO[integrationId];
  let t9;
  if ($[7] !== t8.displayName) {
    t9 = <Text variant="heading20" sx={t7}><var>{t8.displayName}</var> has been synced</Text>;
    $[7] = t8.displayName;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  const t10 = INTEGRATION_INFO[integrationId];
  let t11;
  if ($[9] !== t10.displayName) {
    t11 = <Text variant="bodyM"><var>{t10.displayName}</var> has been enabled in your Sphere XG project</Text>;
    $[9] = t10.displayName;
    $[10] = t11;
  } else {
    t11 = $[10];
  }
  let t12;
  if ($[11] !== t11 || $[12] !== t6 || $[13] !== t9) {
    t12 = <Stack sx={t1}>{t6}{t9}{t11}</Stack>;
    $[11] = t11;
    $[12] = t6;
    $[13] = t9;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== onClose || $[16] !== t12) {
    t13 = <Dialog open={true} title="" onConfirm={onClose} confirmText="Got it">{t12}</Dialog>;
    $[15] = onClose;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  return t13;
}
export const ProjectIntegrationsConnectedDialog = memo(ProjectIntegrationsConnectedDialogComponent);